<div>
  <swiper-container id="C{{componentId}}" #swipers  (click)="click()" [navigation]="navigation" autoHeight="true">

    <swiper-slide *ngFor="let files of publicationList let k = index" style="width: 100% !important;">
      <div >
        <img  *ngIf="checkFileType.checkFileType(files.extension ) == 'image'" class="post-img"
          [src]="'data:image/jpg;base64,' + files.file" loading="lazy">


        <video
          #videoElements
          [appVisibility]="onVisibilityChange"
          *ngIf="checkFileType.checkFileType(files.extension) == 'video'"
          class="post-video"
          controls
          preload="metadata"
          playsinline
          webkit-playsinline
          (loadeddata)="videoElements.currentTime = 0.1"
          (play)="stopvideoService.registerVideoWithEvent($event)"
        >
          <source
            *ngIf="files.extension === 'mp4'"
            [src]="'data:video/mp4;base64,' + files.file"
            type="video/mp4"
          >
          <source
            *ngIf="files.extension === 'MOV'"
            [src]="'data:video/quicktime;base64,' + files.file"
            type="video/quicktime"
          >
        </video>



      </div>
    </swiper-slide>
  </swiper-container>
</div>
